/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { ProtectedRouter } from 'infrastructure/routing';
import { Router, Route } from 'framework/routing';
import ExtensionPageLayout from 'domain/recruiting/candidate/applications/createupdate/Create/layout/ExtensionPageLayout';
import CandidateContextPage from 'domain/recruiting/extension/Show/CandidateContextPage';
import { CreateForm } from 'framework/form';
import { RECRUITING_DASHBOARD_READ } from 'domain/shared/newVacancy';
import { GlobalProtectedRoute } from 'framework/authorization';

const EXTENSION_PATH = '/extension';

const CandidateContextExtensionRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  return (
    <ProtectedRouter basePath={EXTENSION_PATH}>
      <Routes>
        <Route
          path="/candidate/:linkedInId"
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_DASHBOARD_READ}>
              <ExtensionPageLayout isWhiteLogo>
                <CreateForm submitFormFunc={(data: any) => data}>
                  <CandidateContextPage />
                </CreateForm>
              </ExtensionPageLayout>
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

CandidateContextExtensionRouter.getRouterPath = () => `${EXTENSION_PATH}/*`;

export default CandidateContextExtensionRouter;
